// extracted by mini-css-extract-plugin
export default {"text-field":"KitSearchBar2_text-field__QySyQ","btn-panel":"KitSearchBar2_btn-panel__GRqYy"};